import { environmentProd } from '@ups/xplat/environments';
import { deepMerge } from '@ups/xplat/utils';

export const environment = deepMerge(environmentProd, {
  name: process.env['Localize:AppName@web-ryn-replay'],
  production: true,
  // Dedicated Entra SPA app registration for this app (Mel provisioned the
  // client id). Overrides the shared base EntraId:ClientId so this app signs
  // in against its own registration, whose API permission to the replay read
  // API audience is what lets a viewer's token be accepted. authority/audience
  // still come from the shared base (EntraId:Issuer / EntraId:Audience).
  entraId: {
    clientId: process.env['EntraId:SpaClientId@web-ryn-replay'],
  },
  security: {
    appId: process.env['Security:AppId@web-ryn-replay'],
  },
  rynReplay: {
    enabled: process.env['RynReplay:Enabled@prod'] === 'true',
    app: 'web-ryn-replay',
    readApiUrl: process.env['RynReplay:ReadApiUrl@web-ryn-replay'],
  },
  urls: {
    softwareSecurityAPI: process.env['Urls:SoftwareSecurityApi@prod'],
  },
});
